<template>
  <div
    v-if="loading"
    class="clearfix"
  >
    <b-spinner
      class="float-right"
      label="Floated Right"
    />
  </div>
  <div v-else>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <app-collapse type="margin">
          <app-collapse-item
            v-if="verificarPermissao('ROLE_ASSOCIADO_CONSULTAR')"
            title="Informações Pessoais"
          >
            <FormPersonalInfoVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_TIPO_REGISTRO_CONSULTAR')"
            title="Tipo de Registro"
          >
            <FormPersonalRegistryTypeVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_SITUACAO_REGISTRO_CONSULTAR')"
            title="Situação"
          >
            <FormPersonalNotesVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_FAIXA_CONTRIBUICAO_REGISTRO_CONSULTAR')"
            title="Faixa de Contribuição"
          >
            <FormPersonalFaixaContribuicaoVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_DOCUMENTO_CONSULTAR')"
            title="Documentações"
          >
            <FormPersonalDocumentsVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_ENDERECO_CONSULTAR')"
            title="Endereços"
          >
            <FormPersonalEnderecosVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_FONE_CONSULTAR')"
            title="Fones"
          >
            <FormAssocianteFonesVue />
          </app-collapse-item>

          <app-collapse-item title="Assinatura">
            <FormDigitalSignatureVue
              store-name="associantesAdministrativeModule"
              object-name="fullAssociante"
              action-name="editAssocianteDadosPessoais"
              prepare-action-name="prepareToEditFullAssociante"
            />
          </app-collapse-item>
        </app-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BSpinner } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { verificarPermissao } from '@/auth/utils'
import FormPersonalInfoVue from './FormAssociantePersonalInfo.vue'
import FormPersonalDocumentsVue from './FormAssocianteDocuments.vue'
import FormPersonalNotesVue from './FormAssocianteSituation.vue'
import FormPersonalEnderecosVue from './FormAssocianteEnderecos.vue'
import FormAssocianteFonesVue from './FormAssocianteFone.vue'
import FormPersonalRegistryTypeVue from './FormAssocianteTipoRegistro.vue'
import FormPersonalFaixaContribuicaoVue from './FormAssocianteFaixaContribuicao.vue'
import FormAssociantePaymentConfigVue from './FormAssociantePaymentConfig.vue'
import FormDigitalSignatureVue from './FormDigitalSignature.vue'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    FormPersonalInfoVue,
    FormPersonalDocumentsVue,
    FormPersonalNotesVue,
    FormPersonalEnderecosVue,
    FormAssocianteFonesVue,
    FormPersonalRegistryTypeVue,
    FormPersonalFaixaContribuicaoVue,
    FormAssociantePaymentConfigVue,
    FormDigitalSignatureVue,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      verificarPermissao,
      collapseType: 'default',
    }
  },
}
</script>
